import Link, { LinkProps } from './Link'
import LinkPure from './link-pure'

export default Link

export { Link, LinkPure }
export type { LinkProps }
